// extracted by mini-css-extract-plugin
export default {"modernBtn":"dancer-sort-buttons_modernBtn__3nXoW","sortBtnGroup":"dancer-sort-buttons_sortBtnGroup__j6Knk"};